import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import MyContext from "../context/MyContext";

const OrderDetails = () => {
  const context = useContext(MyContext);
  const { history, orderDetails, setOrderDetails } = context;

  const params = useParams();

  useEffect(() => {
    if (params.id) {
      history.forEach((item) => {
        if (item._id === params.id) setOrderDetails(item);
      });
    }
  }, [params.id, history, setOrderDetails]);

  

  if (!orderDetails) return null;

  return (
    <div className="history-page">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Postal Code</th>
            <th>Country Code</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {orderDetails.userId.billAddress
                ? orderDetails.userId.billAddress.fullName
                : orderDetails.userId.deliveryaddress[0].fullName}
            </td>
            <td>
              {orderDetails.userId.billAddress
                ? orderDetails.userId.billAddress.street +
                  " " +
                  orderDetails.userId.billAddress.houseNo
                : orderDetails.userId.deliveryaddress[0].street +
                  " " +
                  orderDetails.userId.deliveryaddress[0].houseNo}
            </td>
            <td>
              {orderDetails.userId.billAddress
                ? orderDetails.userId.billAddress.postCode +
                  " " +
                  orderDetails.userId.billAddress.city
                : orderDetails.userId.deliveryaddress[0].postCode +
                  " " +
                  orderDetails.userId.deliveryaddress[0].city}
            </td>
            <td>
              {orderDetails.userId.billAddress
                ? orderDetails.userId.billAddress.country
                : orderDetails.userId.deliveryaddress[0].country}
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ margin: "30px 0px" }}>
        <thead>
          <tr>
            <th>Img</th>
            <th>Products</th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {orderDetails.cart.map((item) => (
            <tr key={item._id}>
              <td>
                <img src={item.images[0].url} alt="" />
              </td>
              <td>{item.title}</td>
              <td>{item.quantity}</td>
              <td>{item.price * item.quantity} €</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderDetails;
